/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Added by Amanda S (Shopify Theme Support) on Oct 12, 2018 
$(window).on('load', function() {
  var $searchBar = $('#search_bar');
  var $searchIcon = $('#search_button');
  var $headerBarHeight = $('.site-header-sections').outerHeight();
  var $announcementBarHeight = $('.announcement-bar').height() || 0;
  var $restOfSite = $('.main-content, .drawer-cover, .navigation');
 
  function _openSearchBar() {
    $searchBar.css('top', '0').find('.input-group__field').focus();
  }
 
  function _closeSearchBar() {
    $searchBar.css('top', -$headerBarHeight - 20);
    $restOfSite.off();
  }
 
  $searchIcon.removeAttr('style');
  $searchBar.removeAttr('style').css({
    'top': -$headerBarHeight - 20,
    'height': $headerBarHeight,
    'margin-top': $announcementBarHeight
  });
 
  $searchIcon.on('click', function() {
    _openSearchBar();
 
    $restOfSite.on('click', function() {
      event.preventDefault();
      _closeSearchBar();
    })
  })
})
// End of Edited